import script from "./UnitActions.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitActions.vue?vue&type=script&setup=true&lang=js"

import "./UnitActions.vue?vue&type=style&index=0&id=ca980ff4&lang=css"

const __exports__ = script;

export default __exports__